import React from "react";
import LoginForm from "../components/LoginForm";
import Navbar from "../components/Navbar";

export default function Login() {
  return (
    <div style={{ padding: "2rem" }}>
      <Navbar />
      <LoginForm />
    </div>
  );
}
